
namespace RioERP.Products {
    export class ProductsColumns {
        static columnsKey = 'Products.Products';
    }
}